import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import { t } from '../i18n';
import { logIn } from './actions';
import { iOS, isSafari, isChrome } from '../utilities';
import settings from '../constants';
import { ridesumLogo } from '../components/assets';
import Button from '../components/button';
import BecomeTrainerAd from './components/become-trainer-ad';
import classNames from 'classnames';
import './style.scss';

const schema = yup.object().shape({
  email: yup.string().required(t('EMAIL_REQUIRED')),
  password: yup.string().required(t('PASSWORD_REQUIRED')),
});

class Login extends Component {
  state = {
    showWarning: !isSafari && !isChrome,
  };

  login = e => {
    e.preventDefault();
  };

  changeValue = (key, val) => {
    this.setState({
      [key]: val,
    });
  };

  closeWarning = () => this.setState(oldState => ({ showWarning: !oldState.showWarning }));

  render() {
    const isTrainerOrAdminLogin = !new URLSearchParams(this.props.location.search)
      .get('returnUrl')
      ?.includes('/digitalakurser');
    return (
      <div className={classNames('login', isTrainerOrAdminLogin && 'login__extended-view')}>
        <div
          className={classNames(
            'login__item',
            isTrainerOrAdminLogin ? 'login__riders-with-horse-background' : 'login__horse-background',
            'login__white-background',
          )}
        >
          <div className="login__container">
            <div className="login__section">
              <img className="login__logo" src={ridesumLogo} alt="logo" />
              <h3 className="login__subtitle">{t('RIDESUM_SLOGAN')}</h3>
            </div>
            <div className="login__section">
              <Formik
                initialValues={{ email: '', password: '', rememberMe: false }}
                validationSchema={schema}
                onSubmit={({ email, password, rememberMe }) => {
                  const queryParams = new URLSearchParams(this.props.location.search);
                  const returnUrl = queryParams.get('returnUrl');
                  const roleFromQuery = queryParams.get('role');
                  const role = roleFromQuery || (settings.adminEmails.includes(email) ? 'Administrator' : 'Trainer');
                  this.props.logIn({ email, password, role, rememberMe, returnUrl });
                }}
                render={({ values, errors, handleChange, handleBlur, handleSubmit, touched, setFieldValue }) => (
                  <form onSubmit={handleSubmit} className="login__form">
                    <div className="login__inputWrap">
                      <input
                        name="email"
                        value={values.email}
                        onChange={e => setFieldValue('email', e.target.value.trim())}
                        onBlur={handleBlur}
                        placeholder={t('EMAIL')}
                        className={`login__input ${touched.email && errors.email ? 'login__input--red' : null}`}
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                      />
                      {touched.email && errors.email ? <p className="login__errorMessage">{errors.email}</p> : null}
                    </div>
                    {this.state.showWarning ? (
                      <div className="loginMessage">
                        <p className="loginMessage__text">
                          {`${t('WARNING_MESSAGE')}`}
                          <span className="loginMessage__browser">
                            {iOS ? t('BROWSER_SAFARI') : t('BROWSER_CHROME')}
                          </span>
                        </p>
                      </div>
                    ) : (
                      <div className="login__inputWrap">
                        <input
                          type="password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder={t('PASSWORD')}
                          className={`login__input ${touched.password && errors.password ? 'login__input--red' : null}`}
                        />
                        {touched.password && errors.password ? (
                          <p className="login__errorMessage">{errors.password}</p>
                        ) : null}
                      </div>
                    )}
                    <div className="login__remember-me">
                      <input
                        type="checkbox"
                        id="rememberMe"
                        name="rememberMe"
                        defaultChecked={values.rememberMe}
                        onChange={e => setFieldValue('rememberMe', e.target.checked)}
                      />
                      <label htmlFor="rememberMe">{t('REMEMBER_ME')}</label>
                    </div>
                    {errors.server ? <p className="login__errorMessage">{errors.server}</p> : null}
                    <p className="login__errorMessage">{this.props.error}</p>
                    <Button
                      type="green"
                      onClick={e => {
                        if (this.state.showWarning) {
                          return this.closeWarning();
                        }
                        return handleSubmit(e);
                      }}
                      className="login__btn"
                      text={this.state.showWarning ? t('CONTINUE') : t('LOGIN')}
                    />
                  </form>
                )}
              />
              <p className="login__text">{t('REGISTRATION_SUGGESTION')}</p>
              <p className="login__text">{t('FORGOT_PASSWORD_IN_MOBILE_APP')}</p>
              <p className="login__text">
                ver. {process.env.REACT_APP_VERSION}.{process.env.REACT_APP_BUILD_NUMBER}
              </p>
            </div>
          </div>
          {isTrainerOrAdminLogin && <BecomeTrainerAd />}
        </div>
        <div
          className={classNames(
            'login__item login__item--big',
            isTrainerOrAdminLogin ? 'login__riders-with-horse-background' : 'login__horse-background',
          )}
        >
          {isTrainerOrAdminLogin && <BecomeTrainerAd isDesktopOrientation />}
        </div>
      </div>
    );
  }
}

export default withRouter(connect(({ login }) => login, { logIn })(Login));
